import React from 'react';
import { Sparkles, Clock, Heart } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-146">
          <span className="text-[#d4af37] font-semibold tracking-wider uppercase text-sm" data-id="element-147">
            El Método
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a3a52] mt-2 mb-6" data-id="element-148">
            Micro-Pausas de Renovación
          </h2>
          <p className="text-lg text-gray-600" data-id="element-149">
            Imagina un método que no te pida cambiar tu rutina, ni dedicar horas
            que no tienes. Un método que te acompaña justo en el momento en que
            la ansiedad aparece.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
          {/* Feature 1 */}
          <div className="bg-[#f5f1e8] p-8 rounded-2xl border border-[#d4af37]/20 hover:shadow-lg transition-shadow duration-300" data-id="element-151">
            <div className="w-12 h-12 bg-[#1a3a52] rounded-full flex items-center justify-center mb-6 text-[#d4af37]" data-id="element-152">
              <Clock className="w-6 h-6" data-id="element-153" />
            </div>
            <h3 className="text-xl font-serif font-bold text-[#1a3a52] mb-3" data-id="element-154">
              3 Minutos
            </h3>
            <p className="text-gray-700" data-id="element-155">
              Pausas breves diseñadas para encajar en tu día real. No necesitas
              horas de silencio, solo momentos intencionales.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-[#f5f1e8] p-8 rounded-2xl border border-[#d4af37]/20 hover:shadow-lg transition-shadow duration-300" data-id="element-156">
            <div className="w-12 h-12 bg-[#1a3a52] rounded-full flex items-center justify-center mb-6 text-[#d4af37]" data-id="element-157">
              <Sparkles className="w-6 h-6" data-id="element-158" />
            </div>
            <h3 className="text-xl font-serif font-bold text-[#1a3a52] mb-3" data-id="element-159">
              Afirmaciones Poderosas
            </h3>
            <p className="text-gray-700" data-id="element-160">
              Declaraciones que puedes hacer en silencio. Palabras que
              transforman tu estado interior instantáneamente.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-[#f5f1e8] p-8 rounded-2xl border border-[#d4af37]/20 hover:shadow-lg transition-shadow duration-300" data-id="element-161">
            <div className="w-12 h-12 bg-[#1a3a52] rounded-full flex items-center justify-center mb-6 text-[#d4af37]" data-id="element-162">
              <Heart className="w-6 h-6" data-id="element-163" />
            </div>
            <h3 className="text-xl font-serif font-bold text-[#1a3a52] mb-3" data-id="element-164">
              Conexión Interior
            </h3>
            <p className="text-gray-700" data-id="element-165">
              No necesitas una fe rígida, solo la disposición de conectar con
              afirmaciones de renovación y paz.
            </p>
          </div>
        </div>

        {/* Example Box */}
        <div className="mt-16 bg-[#1a3a52] rounded-3xl p-8 md:p-12 text-center text-[#f5f1e8] relative overflow-hidden" data-id="element-166">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-167"></div>
          <div className="relative z-10" data-id="element-168">
            <h3 className="text-2xl font-serif mb-6" data-id="element-169">Visualiza esto:</h3>
            <p className="text-lg md:text-xl italic font-light max-w-3xl mx-auto leading-relaxed" data-id="element-170">
              "La ansiedad comienza a subir, sientes ese nudo en el estómago. En
              lugar de luchar, tomas una pausa. Respiras y declaras:{' '}
              <span className="text-[#d4af37] font-normal" data-id="element-171">
                ‘Cuando en mí la angustia iba en aumento, tu consuelo llenaba mi
                alma de alegría’
              </span>
              . Y en ese instante, el nudo se afloja."
            </p>
          </div>
        </div>
      </div>
    </section>;
}